export const requiredString = (str) => {
  return str !== '';
};

export const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/;
  return email !== '' && email.match(regex);
};

export const validateInt = (int) => {
  return !!int && int > 0 && int <= 10;
};
